import { render } from "./HomeLayout.vue?vue&type=template&id=4c33c922"
const script = {}

import "./HomeLayout.vue?vue&type=style&index=0&id=4c33c922&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__